import { defineStore } from 'pinia';

import Tr from '../../i18n/translation.js';
import GKSCommonInterface from '../../../interface/data/gks/common.js';
import GKSLangInterface from '../../../interface/data/gks/lang.js';
import { useStateStore } from '../state.store.js';
import DataService from '../../services/DataService.js';
import { Logger } from '../../middlewares/sentry.js';

export const useGKSStore = defineStore('gks', {
  state: () => ({
    clientData: {
      common: {
        version: '',
        mainColor: '',
        backgroundColor: '',
        textFont: '',
        hiddenGuests: true,
      },
      lang: {
        pl: {},
      },
    },
    isDataReceived: false,
    isLangDataReceived: false,
  }),
  actions: {
    async trySetupData() {
      await this._setGKSCommonData();
      const lang = Tr.currentLocale;
      this.tryGetLangDataWithImages(lang);
    },
    async _setGKSCommonData() {
      if (!this.isDataReceived) {
        await this._tryGetGKSCommonData();
        this.isDataReceived = true;
      } else {
        new Promise(async () => {
          this._tryGetGKSCommonData();
        });
      }

      const { setColors } = useStateStore();
      setColors(
        this.clientData.common.mainColor,
        this.clientData.common.mainColor,
        this.clientData.common.backgroundColor,
      );
    },
    async _tryGetGKSCommonData() {
      try {
        const data = await DataService.getGKSData();
        this.clientData.common = new GKSCommonInterface(data);
      } catch (err) {
        Logger.error(err);
        if (!this.isDataReceived) {
          this.clientData.common = new GKSCommonInterface({});
        }
      }
    },
    async tryGetLangDataWithImages(lang) {
      await this._setGetLangData(lang);
    },
    async _setGetLangData(lang) {
      if (!this.isLangDataReceived) {
        await this.tryGetLangData(lang);
        this.isLangDataReceived = true;
      } else {
        new Promise(async () => {
          this.tryGetLangData(lang);
        });
      }
    },
    async tryGetLangData(lang) {
      try {
        const data = await DataService.getGKSData(lang);
        this.clientData.lang[lang] = new GKSLangInterface(data);
      } catch (err) {
        Logger.error(err);
        if (!this.isLangDataReceived) {
          const { getDefaultLang } = useStateStore();

          if (lang !== getDefaultLang) {
            this.tryGetLangData(getDefaultLang);
            return;
          }

          this.clientData.lang[lang] = new GKSLangInterface({});
        }
      }
    },
    resetData() {
      this.clientData.common = {
        version: '',
        mainColor: '',
        backgroundColor: '',
        textFont: '',
        hiddenGuests: true,
      };
    },
  },
  getters: {
    getCommonData: (state) => state.clientData.common,
  },
});
